export default class UserVendorViewAPIRequest {
    asVendor: boolean;

    constructor(asVendor: boolean) {
        this.asVendor = asVendor;
    }
}
